import React, { useEffect, useState } from 'react';
import ApprovalsTechnicalConceptView from '../views/ApprovalsTechnicalConceptView';
import { useSectionals } from '../../../../share';
import useFormikConceptFilters from '../../../../utils/validators/concept/concept-filter-validators';
import { TechnicalFilter } from '../../../TechnicalConcept/types/technical-concept';
import TechnicalConceptDetailContainer from '../../../TechnicalConcept/components/containers/TechnicalConceptDetailContainer';
import { useFetchApprovalsTechnicalConcept } from '../../../../hooks/approvalsTechnicalConcept/approvalsTechnicalConcept';

const TechnicalConceptContainer: React.FC = () => {
  const [filter, setFilter] = React.useState<TechnicalFilter>();
  const { data: sectionals } = useSectionals();
  const [modalState, setModalState] = useState(false);
  const [technicalId, setTechnicalId] = useState<string | undefined>();

  const {
    data: entries,
    isPending: loadList,
    refetch,
  } = useFetchApprovalsTechnicalConcept(filter);

  const handleFilter = async (values: Partial<TechnicalFilter>) => {
    setFilter({
      ...values,
      created_at: values.created_at
        ? new Date(values.created_at).toISOString().split('T')[0]
        : '',
    });
  };

  const formikFilter = useFormikConceptFilters({ onSubmit: handleFilter });

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };
  useEffect(() => {
    refetch();
  }, [filter]);
  return (
    <>
      <ApprovalsTechnicalConceptView
        isLoading={loadList}
        data={entries}
        sectionals={sectionals}
        formik={formikFilter}
        onViewDetail={(id: string) => {
          setModalState(true);
          setTechnicalId(id ?? '');
        }}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formikFilter.resetForm();
        }}
      />

      {!loadList && (
        <TechnicalConceptDetailContainer
          isOpen={modalState}
          OnClose={() => {
            setModalState(false)
          }}
          technicalId={technicalId}
          onViewDetail={() => setModalState(true)}
          isViewApproved
          fromApprvals={true}
          setFilter={setFilter}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default TechnicalConceptContainer;
